// DKM-5339 Clara: eski hâli
// import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { Component, EventEmitter, NgZone, OnDestroy, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxDropDownBoxModule, DxDropDownButtonModule, DxPopupModule } from 'devextreme-angular';
import { HttpClient } from '@angular/common/http';
import { UtilsService } from '../../services/utils.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';


export interface DabScanDto{
  Content:string;
  DocType:string;
  Success:string;
  ErrorMessage:string;
}
@Component({
  selector: 'dk-document-scanner4-naps2',
  standalone: true,
  imports: [CommonModule,DxDropDownButtonModule,DxPopupModule,DxButtonModule],
  templateUrl: './document-scanner4-naps2.component.html',
  styleUrls: ['./document-scanner4-naps2.component.scss'],
})
export class DocumentScanner4Naps2Component implements OnDestroy {
  @Output() base64Content = new EventEmitter<string>();
  
  napsDabUrl="http://localhost:9876/DabScan?ReqCount=";

  pdfPage:string[]=["Tüm Sayfalar","Seçilen Sayfalar"];
  showScannedDocument=false;
  fileUrl: SafeResourceUrl;
  fileContent:string;
  showOpenScanApp=false;
  reqCount=0;

  private shouldShowPopup = false;
  private destroy$ = new Subject<void>();
  private socket$: WebSocketSubject<any>;
  private taramaBekleniyor = false;
  private yenidenBaglanmaSayisi = 0;
  private yenidenBaglanmaTimer: number;
  private readonly MAKS_YENIDEN_BAGLANMA = 5;
  /**
   * DKM-5339 Clara: "Aç" ile DABS başlatılınca uygulamanın 9876 portunu açması birkaç saniye sürüyor. Eskiden bağlantı
   * hemen denenip reddedilince uyarı anında geri geliyordu ("Aç" döngüsü). Bu süre içinde bağlantı her saniye yeniden denenir.
   */
  // DKM-5487 Cedric: eski hâli — 20 sn yetmiyordu (Eyyübiye): tarayıcının "dabs2 açılsın mı?" sorusu + yavaş makinede DABS'ın
  // açılışı 20 sn'yi aşınca web vazgeçiyor, uyarıyı kapatınca bekleme iptal oluyordu; kullanıcı DABS'ta tarayıp "Dab App Gönder"e
  // bastığında DABS'a bağlı bekleyen ekran olmadığı için düğme sessizce hiçbir şey yapmıyordu.
  // private readonly DABS_ACILIS_BEKLEME_MS = 20000;
  /**
   * DKM-5487 Cedric: DABS'a henüz bağlanılamamışken (kapalı ya da açılıyor) bağlantı bu süre boyunca saniyede bir yeniden denenir.
   * "Aç" ile ya da masaüstünden DABS açıldığı anda bağlantı kurulur ve tarama beklemesi başlar (uyarı penceresi açıkken de).
   */
  private readonly DABS_ACILIS_BEKLEME_MS = 180000;
  private acilisSonu = 0;
  /** DKM-5339 Clara: "Aç"tan sonra DABS'ın açılması bekleniyor (bekleme penceresinde bilgi satırı). */
  dabsAciliyor = false;
  /** DKM-5487 Cedric: "DABS açık olmalı" uyarısı görünürken arka planda DABS'ın açılması bekleniyor (uyarıda bilgi satırı). */
  dabsArkaPlandaBekleniyor = false;

  // DKM-5339 Clara: eski hâli
  // constructor(private httpClient:HttpClient,private utilService:UtilsService,public sanitizer: DomSanitizer){}
  constructor(private httpClient:HttpClient,private utilService:UtilsService,public sanitizer: DomSanitizer, private zone: NgZone){
    DocumentScanner4Naps2Component.kanalKur();
  }

  /**
   * DKM-5339 Clara: DABS "Dab App Gönder"de dosyayı kendisine bağlı EN ESKİ açık bağlantıya yollar
   * (DABS2 WebSocketManager.GetAnyAvailableSocket → FirstOrDefault). Başka bir ekran/sekme de taramayı beklerken
   * (route-tab'lar arka planda canlı kalır; ikinci tarayıcı sekmesi) dosya oraya gidiyor, kullanıcının baktığı ekran
   * "Tarama Bekleniyor"da kalıyordu — 17.10.2026'da gerçek DABS ile tekrar üretildi. Artık aynı anda tek bekleyen tarama olur:
   * yeni tarama başlayınca bu sekmedeki ve (BroadcastChannel ile) diğer sekmelerdeki bekleyen taramalar iptal edilir.
   */
  private static bekleyenTarama: DocumentScanner4Naps2Component | null = null;
  private static kanal: BroadcastChannel | null = null;
  private static kanalKur(): void {
    if (DocumentScanner4Naps2Component.kanal || typeof BroadcastChannel === 'undefined') return;
    try {
      const kanal = new BroadcastChannel('dk-dabs-tarama');
      kanal.onmessage = (e: MessageEvent) => {
        if (e?.data?.tip === 'taramaBasladi') DocumentScanner4Naps2Component.bekleyenTarama?.baskaYerdeBasladi();
      };
      DocumentScanner4Naps2Component.kanal = kanal;
    } catch {
      DocumentScanner4Naps2Component.kanal = null;
    }
  }

  /** DKM-5339 Clara: başka ekranda/sekmede tarama başladı → buradaki bekleme bırakılır ki DABS dosyayı oraya göndersin. */
  private baskaYerdeBasladi(): void {
    this.zone.run(() => {
      if (!this.taramaBekleniyor && !this.showScanLoading) return;
      this.cancelScanJob();
      this.showScanLoading = false;
      this.showOpenScanApp = false; // DKM-5487 Cedric: arka planda DABS beklenirken açık kalan uyarı da kapanır
      this.utilService.showWarning('Tarama başka bir ekranda başlatıldı; bu ekrandaki DABS beklemesi iptal edildi.', 'DABS');
    });
  }
 
  endpointUrl=this.napsDabUrl
  private progressTimer: number;
  showScanLoading=false;
//   doScan(): void {
//     this.showScannedDocument=false;
 
 

//     // if(e.itemData === 'Tüm Sayfalar'){
//     //   if(!this.endpointUrl.includes('All'))
//     //        this.endpointUrl+='All';
//     // }
//     // else{
//     //   if(!this.endpointUrl.includes('Selected'))
//     //       this.endpointUrl+='Selected';
//     // }
// console.log("url",this.endpointUrl)
// this.sendIntervalHttpReq();
//     // this.httpClient.get<DabScanDto>(endpointUrl).subscribe({
//     //   next:(res)=>{
//     //     console.log("res",res)
//     //     if(res.Success){
//     //     if(res.Content){
//     //       console.log("DocScan",res.Content); 
//     //       this.showScannedDocument=true; 

//     //       if(res.DocType==='pdf'){
//     //         this.fileContent=res.Content;
//     //         const byteCharacters = atob(res.Content);

//     //         const byteNumbers = new Array(byteCharacters.length);
//     //         for (let i = 0; i < byteCharacters.length; i++) {
//     //           byteNumbers[i] = byteCharacters.charCodeAt(i);
//     //         }
//     //         const byteArray = new Uint8Array(byteNumbers);
//     //         const blob = new Blob([byteArray], { type: "application/pdf"});
//     //         const url = URL.createObjectURL(blob);
//     //         this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
//     //       }
//     //     }
//     //     else{
        
//     //       this.utilService.showError("Dosya bulunamadı","Başarısız");
//     //     }
//     //   }
//     //   else{
//     //     this.utilService.showError(res?.ErrorMessage,"Başarısız");
//     //   }
//     //   },
//     //   error:(err)=>{
//     //   //  this.utilService.showError("Uygulamaya Erişılemiyor","Başarısız");
//     //     this.showOpenScanApp=true;

//     //   }
//     // })

//   }

doScan(): void {
  // DKM-5339 Clara: "DABS Tarama" düğmesi — DABS kapalıysa uyarı eskisi gibi hemen gelir (açılış beklemesi yok)
  this.acilisSonu = 0;
  this.dabsAciliyor = false;
  this.dabsArkaPlandaBekleniyor = false; // DKM-5487 Cedric
  this.taramayiBaslat();
}

/**
 * DKM-5487 Cedric: "Tarama Bekleniyor" penceresi kapanınca (eskiden doğrudan cancelScanJob). Pencere, DABS'a ulaşılamadığı için
 * uyarıya geçmek üzere kapatıldıysa arka planda DABS beklemesi sürer; kullanıcı kapattıysa (×, İptal) tarama iptal edilir.
 */
beklemePenceresiKapandi(): void {
  if (this.showOpenScanApp && this.dabsArkaPlandaBekleniyor) return;
  this.cancelScanJob();
}

/** DKM-5339 Clara: doScan'in eski gövdesi; "Aç" akışı da bunu açılış beklemesiyle çağırır. */
private taramayiBaslat(): void {
  // DKM-5339 Clara: aynı anda tek bekleyen tarama (bkz. bekleyenTarama açıklaması)
  const onceki = DocumentScanner4Naps2Component.bekleyenTarama;
  if (onceki && onceki !== this) onceki.baskaYerdeBasladi();
  DocumentScanner4Naps2Component.bekleyenTarama = this;
  try { DocumentScanner4Naps2Component.kanal?.postMessage({ tip: 'taramaBasladi' }); } catch { /* yoksay */ }
  this.showScannedDocument = false;
  this.showScanLoading = true;
  this.taramaBekleniyor = true;
  this.yenidenBaglanmaSayisi = 0;
  this.baglan();
}

/**
 * DABS, "Dab App Gönder"e basıldığında PDF'i o an AÇIK olan bir socket'e gönderir;
 * açık socket yoksa hiçbir uyarı vermeden işlemi bırakır. Eskiden bekleme sürerken
 * bağlantı kapanırsa (complete) hiçbir şey yapılmıyordu: ekran "Tarama Bekleniyor"da
 * kalıyor, DABS'taki buton ise tepki vermiyordu. Artık tarama beklenirken bağlantı
 * düşerse otomatik yeniden bağlanılıyor.
 */
private baglan(): void {
  this.socketKapat();
  this.reqCount += 1;

  let acildi = false;
  const socket$ = webSocket<any>({
    url: 'ws://localhost:9876',
    openObserver: {
      next: () => {
        acildi = true;
        this.yenidenBaglanmaSayisi = 0;
        // DKM-5339 Clara: DABS'a ulaşıldı, açılış beklemesi bitti
        this.acilisSonu = 0;
        this.dabsAciliyor = false;
        // DKM-5487 Cedric: uyarı açıkken (arka planda beklenirken) DABS açıldı → uyarı kapanır, "Tarama Bekleniyor" gelir.
        // Sıra önemli: önce bekleme penceresi, sonra uyarı kapanır ki uyarının onHiding'i (closeScanApp) taramayı iptal etmesin.
        if (this.dabsArkaPlandaBekleniyor || this.showOpenScanApp) {
          this.showScanLoading = true;
          this.showOpenScanApp = false;
        }
        this.dabsArkaPlandaBekleniyor = false;
        console.log('[DABS] Bağlantı açıldı.');
      }
    },
    closeObserver: {
      next: (e: CloseEvent) =>
        console.log(`[DABS] Bağlantı kapandı. code=${e.code} reason=${e.reason || '-'} wasClean=${e.wasClean}`)
    }
  });
  this.socket$ = socket$;

  socket$.subscribe({
    next: (res: DabScanDto) => {
      console.log('WebSocket Response:', res);
      if (res.Success && res.Content) {
        this.handleDocument(res);
      } else {
        //this.utilService.showError(res.ErrorMessage, "Başarısız");
        // DKM-5339 Clara (dönüş): DABS sürümü 1.0.4 değilse DABS "DABS Versionu 1.0.4 olmalıdır" yanıtını içeriksiz yollayıp
        // başka hiçbir şey göndermiyor; ekran sonsuza kadar "Tarama Bekleniyor"da kalıyordu. Diğer içeriksiz yanıtlar
        // (DABS'taki scanned.pdf deneme kodunun her startScan'de yolladığı hata) eskisi gibi yok sayılır.
        if (res?.ErrorMessage && /versi?yon|version/i.test(res.ErrorMessage)) {
          this.cancelScanJob();
          this.utilService.showError('Bilgisayardaki DABS sürümü Dabnet ile uyumlu değil (1.0.4 gerekli). DABS\'ı güncelleyip tekrar deneyin.', 'DABS sürümü');
          return;
        }
        this.showScanLoading = true;
      }
    },
    error: (err) => {
      // Kendi kapattığımız eski bir socket'in olayı ise yoksay
      if (this.socket$ !== socket$) return;
      console.error('WebSocket Error:', err);
      this.beklenmedikKapanma(acildi);
    },
    complete: () => {
      if (this.socket$ !== socket$) return;
      console.log('WebSocket closed.');
      this.beklenmedikKapanma(acildi);
    }
  });

  // reqCount > 1 iken DABS pencereyi tekrar öne getirmez
  socket$.next({ command: 'startScan', reqCount: this.reqCount });
}

private beklenmedikKapanma(acildi: boolean): void {
  this.socket$ = null;
  if (!this.taramaBekleniyor) return;

  // DKM-5339 Clara: "Aç"tan sonra DABS daha port açmadıysa (açılış süresi) uyarı göstermeden her saniye tekrar dene
  if (!acildi && Date.now() < this.acilisSonu) {
    this.reqCount = 0; // bağlanınca DABS'a reqCount=1 gitsin → DABS penceresini öne getirsin
    window.clearTimeout(this.yenidenBaglanmaTimer);
    this.yenidenBaglanmaTimer = window.setTimeout(() => {
      if (this.taramaBekleniyor) this.baglan();
    }, 1000);
    return;
  }

  // Hiç açılamadıysa DABS çalışmıyor demektir: eski davranış, uyarıyı göster
  if (!acildi || this.yenidenBaglanmaSayisi >= this.MAKS_YENIDEN_BAGLANMA) {
    // DKM-5487 Cedric: uyarı gösterilir ama ilk seferde bekleme bırakılmaz — uyarı açıkken arka planda saniyede bir denenir;
    // kullanıcı DABS'ı ("Aç" ya da masaüstü) açtığı anda bağlantı kurulur, uyarı kendiliğinden "Tarama Bekleniyor"a döner.
    // Süre (DABS_ACILIS_BEKLEME_MS) dolmuşsa eskisi gibi bekleme biter.
    this.dabsAciliyor = false;
    this.showOpenScanApp = true; // önce uyarı: bekleme penceresinin kapanışı (beklemePenceresiKapandi) taramayı iptal etmesin
    this.showScanLoading = false;
    if (this.acilisSonu === 0) {
      this.acilisSonu = Date.now() + this.DABS_ACILIS_BEKLEME_MS;
      this.dabsArkaPlandaBekleniyor = true;
      this.reqCount = 0; // bağlanınca DABS'a reqCount=1 gitsin → DABS penceresini öne getirsin
      window.clearTimeout(this.yenidenBaglanmaTimer);
      this.yenidenBaglanmaTimer = window.setTimeout(() => {
        if (this.taramaBekleniyor) this.baglan();
      }, 1000);
    } else {
      this.cancelScanJob();
    }
    // DKM-5487 Cedric: eski hâli
    // this.taramaBekleniyor = false;
    // this.dabsAciliyor = false;
    // this.acilisSonu = 0;
    // // DKM-5339 Clara: "Tarama Bekleniyor" penceresi de kapatılır. Eskiden açık kalıyordu; uyarı (aynı boyutta, tam üstünde)
    // // onu örtüyordu. Uyarıda "İptal"e basılınca closeScanApp, bekleme açık diye taramayı iptal etmiyor; ekran bağlantısız
    // // "Tarama Bekleniyor"da kalıyor, DABS'tan gönderilen dosya hiçbir yere gitmiyordu. Kapanınca onHiding → cancelScanJob.
    // this.showScanLoading = false;
    // this.showOpenScanApp = true;
    return;
  }

  this.yenidenBaglanmaSayisi += 1;
  console.warn(`[DABS] Tarama beklenirken bağlantı düştü, yeniden bağlanılıyor (${this.yenidenBaglanmaSayisi}/${this.MAKS_YENIDEN_BAGLANMA})`);
  window.clearTimeout(this.yenidenBaglanmaTimer);
  this.yenidenBaglanmaTimer = window.setTimeout(() => {
    if (this.taramaBekleniyor) this.baglan();
  }, 1000);
}

private socketKapat(): void {
  window.clearTimeout(this.yenidenBaglanmaTimer);
  const socket$ = this.socket$;
  // Önce null'la ki complete/error handler'ları bunu beklenmedik kapanma saymasın
  this.socket$ = null;
  if (socket$ && !socket$.closed) {
    try {
      socket$.complete();
    } catch (err) {
      console.log('Socket Error:', err);
    }
  }
}


private handleDocument(res: DabScanDto) {
  this.fileContent = res.Content;


  const sliceSize   = 1024;  
  const byteChars   = atob(res.Content);
  const byteLength  = byteChars.length;
  const slicesCount = Math.ceil(byteLength / sliceSize);
  const byteArrays  = new Array<Uint8Array>(slicesCount);

  for (let slice = 0; slice < slicesCount; slice++) {
    const begin = slice * sliceSize;
    const end   = Math.min(begin + sliceSize, byteLength);
    const bytes = new Uint8Array(end - begin);

    for (let i = begin; i < end; i++) {
      bytes[i - begin] = byteChars.charCodeAt(i);
    }
    byteArrays[slice] = bytes;
  }

  const blob = new Blob(byteArrays, { type: 'application/pdf' });

  const url = URL.createObjectURL(blob);
  this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

  this.taramaBekleniyor = false;
  this.showScannedDocument = true;
  this.showScanLoading = false;
  this.showOpenScanApp = false;
}


  sendIntervalHttpReq(){
    this.showScanLoading=true;
  this.progressTimer=  window.setInterval(()=>{
    this.reqCount+=1;
    const url = this.endpointUrl+ this.reqCount;
      this.httpClient.get<DabScanDto>(url) .pipe(takeUntil(this.destroy$)).subscribe({
        next:(res)=>{
          console.log("res",res)
          if(res.Success){
          if(res.Content){
            window.clearInterval(this.progressTimer);
            console.log("DocScan",res.Content); 
            this.showScannedDocument=true; 
            this.showScanLoading=false;
            this.showOpenScanApp=false;
            if(res.DocType==='pdf'){
              this.fileContent=res.Content;
              const byteCharacters = atob(res.Content);
  
              const byteNumbers = new Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              const byteArray = new Uint8Array(byteNumbers);
              const blob = new Blob([byteArray], { type: "application/pdf"});
              const url = URL.createObjectURL(blob);
              this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
            }
          }
          else{
          
            this.utilService.showError("Dosya bulunamadı","Başarısız");
          }
        }
        else{
          this.utilService.showError(res?.ErrorMessage,"Başarısız");
        }
        },
        error:(err)=>{
          console.log("Hata:",err);
          console.log("show should",this.shouldShowPopup)
          if(!this.shouldShowPopup && !this.showScannedDocument){
          this.shouldShowPopup=true;
           this.showOpenScanApp=true;}
           this.destroy$.next();

        }
      })

    },3000)
  }
 

  saveBase64File(){
    this.showScannedDocument = false
    this.base64Content.emit("data:application/pdf;base64,"+this.fileContent);

    this.taramaBekleniyor = false;
    this.socketKapat();
  }

  closePdfPreview($e:any){
    this.showScannedDocument = false
    this.taramaBekleniyor = false;
    this.socketKapat();
  }

  // DKM-5339 Clara: eski hâli — bağlantı DABS port açmadan hemen deneniyor, reddedilince uyarı anında geri geliyordu
  //   openScanApp(){
  //      window.location.href = 'dabs2://open';
  // this.showOpenScanApp = false;
  // this.doScan();
  //    }
  openScanApp(){
    window.location.href = 'dabs2://open';
    this.showOpenScanApp = false;
    // DABS açılırken (en çok DABS_ACILIS_BEKLEME_MS) bağlantı reddedilirse uyarı yerine yeniden dene
    this.acilisSonu = Date.now() + this.DABS_ACILIS_BEKLEME_MS;
    this.dabsAciliyor = true;
    this.dabsArkaPlandaBekleniyor = false; // DKM-5487 Cedric: artık "Tarama Bekleniyor" penceresinde bekleniyor
    this.taramayiBaslat();
  }
  // downloadScanApp() {
  //   const fileUrl = 'assets/DABS2-1.0.2.exe';
  //   const a = document.createElement('a');
  //   a.href = fileUrl;
  //   a.download = 'DABS2-1.0.2.exe';
  //   document.body.appendChild(a);
  //   a.click();
  //   document.body.removeChild(a);
  //   this.showOpenScanApp = false;
  // }

    cancelScanJob(){
      window.clearInterval(this.progressTimer);
      this.showScanLoading=false;
      this.reqCount=0;
      this.shouldShowPopup=false;
      this.destroy$.next();
     // this.destroy$.complete();
      this.taramaBekleniyor = false;
      this.dabsAciliyor = false; // DKM-5339 Clara
      this.acilisSonu = 0;       // DKM-5339 Clara
      this.dabsArkaPlandaBekleniyor = false; // DKM-5487 Cedric
      if (DocumentScanner4Naps2Component.bekleyenTarama === this) DocumentScanner4Naps2Component.bekleyenTarama = null; // DKM-5339 Clara
      this.socketKapat();
    }

   closeScanApp(){
    if(!this.showScanLoading){
    this.cancelScanJob();
    }
     this.reqCount=0;
    this.shouldShowPopup=false;
    this.showOpenScanApp = false;
  }

  // ngOnDestroy(): void {
  //  this.cancelScanJob(); 
  //  this.destroy$.next();
  //  this.destroy$.complete();
  // }


  ngOnDestroy(): void {
    this.cancelScanJob();
    this.destroy$.next();
    this.destroy$.complete();
    this.socketKapat();
  }
}


